import { Component } from '@angular/core';
import { IconDefinition, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faCircle } from '@fortawesome/free-solid-svg-icons';
import { fadeIn } from 'src/app/animations/fade-in';

@Component({
    animations: [fadeIn],
    selector: 'app-whatsapp-us',
    templateUrl: 'whatsapp-us.component.html',
    styleUrls: ['whatsapp-us.component.scss']
})
export class WhatsappUpComponent {
    public faCircle: IconDefinition = faCircle;
    public faWhatsapp: IconDefinition = faWhatsapp;
}
